import template from './rw-homepage-links.html';

export default {
  template,
  controller: 'RwHomepageLinksController',
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-homepage-links/rw-homepage-links-component.js